import { SAVE_ODSP_DATA } from 'constants/reduxActions';
import type { OdspData } from 'types/opal';
import type { OnDemandSizingAction } from 'actions/productdetail/onDemandSizing';

export type OnDemandSizeState = OdspData | {};

const onDemandSize = (state: OnDemandSizeState = {}, action: OnDemandSizingAction): OnDemandSizeState => {
  switch (action.type) {
    case SAVE_ODSP_DATA:
      const { data } = action;
      return data;
    default:
      return state;
  }
};

export default onDemandSize;
